import { render, staticRenderFns } from "./RecordPlayer.vue?vue&type=template&id=01010b30"
import script from "./RecordPlayer.vue?vue&type=script&lang=js"
export * from "./RecordPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports